export default {
  zh:{
    "invtieText":"邀请",
    "hanleSuc":"邀请成功",
    "searchPolad":"搜索昵称或ID",
    "hanleErr":"邀请失败，请稍后重试",
    "searchEmptyTrxt":"没有搜索结果",
    "searchText":"搜索",
  },
  ar:{
    "invtieText":"يدعو",
    "hanleSuc":"تمت الدعوة بنجاح",
    "searchPolad":"البحث عن اللقب أو الهوية",
    "hanleErr":"فشلت الدعوة، يرجى المحاولة مرة أخرى لاحقًا",
    "searchText":"يبحث",
    "searchEmptyTrxt":"لا نتائج للبحث",
  },
  tr:{
    "invtieText":"Davet Et",
    "hanleSuc":"Başarıyla Davet Edildi",
    "searchPolad":"Takma Ad veya Kimliğe Göre Arayın",
    "hanleErr":"Davet başarısız oldu, lütfen daha sonra tekrar deneyin",
    "searchText":"Ara",
    "searchEmptyTrxt":"Arama Sonucu Yok",
  },
  en:{
    "invtieText":"Invite",
    "hanleSuc":"Invite successfully",
    "searchPolad":"Search by nickname or ID",
    "hanleErr":"Invite failed,please try again later",
    "searchText":"Search",
    "searchEmptyTrxt":"No search result",
  },
  uz:{
  "invtieText": "Taklif qilish",
  "hanleSuc": "Taklif muvaffaqiyatli",
  "searchPolad": "Nik yoki ID bo‘yicha qidirish",
  "hanleErr": "Taklif qilishda xatolik, iltimos, keyinroq qayta urinib ko‘ring",
  "searchText": "Qidirish",
  "searchEmptyTrxt": "Natijalar topilmadi"
},
    ru:{
  "invtieText": "Пригласить",
  "hanleSuc": "Приглашение успешно",
  "searchPolad": "Поиск по никнейму или ID",
  "hanleErr": "Не удалось пригласить, попробуйте позже",
  "searchText": "Поиск",
  "searchEmptyTrxt": "Нет результатов поиска"
},
    fa:{
  "invtieText": "دعوت",
  "hanleSuc": "دعوت با موفقیت انجام شد",
  "searchPolad": "جستجو بر اساس نام مستعار یا شناسه",
  "hanleErr": "دعوت ناموفق بود، لطفاً بعداً تلاش کنید",
  "searchText": "جستجو",
  "searchEmptyTrxt": "نتیجه‌ای یافت نشد"
},
    pt:{
  "invtieText": "Convidar",
  "hanleSuc": "Convite bem-sucedido",
  "searchPolad": "Buscar por apelido ou ID",
  "hanleErr": "Falha ao convidar, por favor tente novamente mais tarde",
  "searchText": "Buscar",
  "searchEmptyTrxt": "Nenhum resultado encontrado"
},
    id:{
  "invtieText": "Undang",
  "hanleSuc": "Undangan berhasil",
  "searchPolad": "Cari berdasarkan nama panggilan atau ID",
  "hanleErr": "Undangan gagal, silakan coba lagi nanti",
  "searchText": "Cari",
  "searchEmptyTrxt": "Tidak ada hasil pencarian"
}




}



// WEBPACK FOOTER //
// src/pages/app/invite-member/lang.js